/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var EmptyCommentsIcon = createIcon("EmptyCommentsIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "120",
    height: "120",
    viewBox: "0 0 120 120",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M60 120c33.137 0 60-26.863 60-60S93.137 0 60 0 0 26.863 0 60s26.863 60 60 60Z",
    fill: "#CFCEFD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".35",
    d: "M40 93.135V83h-8a2 2 0 01-2-2V46a2 2 0 012-2h46a2 2 0 012 2v35a2 2 0 01-2 2H52.162L40 93.135Z",
    fill: "#A5AEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 87.135V77h-8a2 2 0 01-2-2V40a2 2 0 012-2h46a2 2 0 012 2v35a2 2 0 01-2 2H58.162L46 87.135Z",
    fill: "#0C0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.438 75H83a1 1 0 001-1V41a1 1 0 00-1-1H39a1 1 0 00-1 1v33a1 1 0 001 1h9v7.865L57.438 75Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 60a3 3 0 100-6 3 3 0 000 6Zm12 0a3 3 0 100-6 3 3 0 000 6Zm-24 0a3 3 0 100-6 3 3 0 000 6Z",
    fill: "#665AF4"
  }));
}, {
  "i18nKey": "svg.EmptyCommentsIcon"
});